var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaStudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_786_21585)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14.5,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14.5,
    r: 11.7798,
    stroke: "#E8E8E8",
    strokeWidth: 0.44046
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9481 10.6267L17.9678 12.1131L16.9481 13.5993M19.6019 10.6267L20.6218 12.1131L19.6019 13.5993M22.2556 10.6267L23.2755 12.1131L22.2556 13.5993M14.8618 13.5993H25.1473M21.5384 15.9999L19.4862 14.8742C19.4325 14.8447 19.3716 14.8291 19.3096 14.8291C19.2476 14.8291 19.1867 14.8446 19.1329 14.874C19.0792 14.9035 19.0346 14.9458 19.0036 14.9968C18.9726 15.0479 18.9563 15.1057 18.9564 15.1647V17.4158C18.9563 17.4747 18.9726 17.5326 19.0036 17.5836C19.0346 17.6346 19.0792 17.677 19.1329 17.7065C19.1867 17.7359 19.2476 17.7514 19.3096 17.7514C19.3716 17.7513 19.4325 17.7358 19.4862 17.7063L21.5384 16.5808C21.592 16.5514 21.6366 16.5091 21.6676 16.4581C21.6986 16.4071 21.715 16.3492 21.715 16.2904C21.715 16.2315 21.6986 16.1736 21.6676 16.1227C21.6366 16.0717 21.592 16.0293 21.5384 15.9999Z",
    stroke: "#0869FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5915 9.35767H15.4178C15.2703 9.35767 15.1289 9.41331 15.0247 9.51235C14.9204 9.61139 14.8618 9.74573 14.8618 9.8858V18.5999C14.8618 18.74 14.9204 18.8743 15.0247 18.9734C15.1289 19.0724 15.2703 19.1281 15.4178 19.1281H24.5915C24.739 19.1281 24.8804 19.0724 24.9847 18.9734C25.089 18.8743 25.1475 18.74 25.1475 18.5999V9.8858C25.1475 9.74573 25.089 9.61139 24.9847 9.51235C24.8804 9.41331 24.739 9.35767 24.5915 9.35767V9.35767Z",
    stroke: "#0869FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_786_21585",
    x: 0.952641,
    y: 0.73816,
    width: 38.0947,
    height: 38.0947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.28552
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52368
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_786_21585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_786_21585",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaStudio);
export default __webpack_public_path__ + "static/media/MediaStudio.b6bd1aee0b2eac739b64d0a17b518f41.svg";
export { ForwardRef as ReactComponent };